export const STATIC_PROPERTIES = [
  {
    id: "unit-317-775-academy-way",
    title: "Unit 317 – 775 Academy Way",
    description: "Step into modern student living with this bright and spacious 2-bedroom, 2-bathroom unit located just steps from UBCO. Featuring an open-concept layout, full-sized appliances, in-suite laundry, and a private balcony with hillside views, this suite offers both comfort and convenience.",
    address: "775 Academy Way, Kelowna, BC",
    rent: "Contact to know more",
    bedrooms: 2,
    bathrooms: 2,
    property_type: "Student Housing",
    availability_date: "Available Now",
    is_available: true,
    amenities: [
      "In-suite laundry",
      "Full kitchen with appliances", 
      "Private balcony",
      "2 full bathrooms",
      "5-minute walk to UBCO"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/1fhpjla9_775-academy-way-u-three-ubco-kelowna-investment-property-living-room.jfif",
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/4ts3x8u9_317-775-Academy-Patio.jpg",
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/n7tilmte_patio-view-u3.jpg",
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/kvnh62fc_775-Academy_lobby.jpg",
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/bqekxujv_775-academy-way-u-three-3rdfloor-elevator.jfif",
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/r1rueiyv_U-Three_Driveway.jpg",
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/talgwjxc_U-Three_Lobby.jfif",
      "https://customer-assets.emergentagent.com/job_lyle-realty/artifacts/eqvl3rde_317-775-Academy-Way-floor-plan.jpg"
    ],
    contact_info: "Lyle Patel",
    whatsapp_link: "https://api.whatsapp.com/message/RBQYKNFZADHKI1?autoload=1&app_absent=0",
    drive_folder: "https://drive.google.com/drive/folders/1tV2JlMbLWZy_Y-AxV8qz4IwPD_mM8nBr"
  },
  {
    id: "unit-105-935-academy-way",
    title: "Unit 105 – 935 Academy Way", 
    description: "This ground-floor 2-bedroom, 2-bathroom suite offers spacious interiors and direct walk-out patio access. With plenty of natural light, a functional kitchen, and individual bathrooms, it's ideal for roommates or professionals looking for easy access to UBCO and surrounding trails.",
    address: "935 Academy Way, Kelowna, BC",
    rent: "Contact to know more",
    bedrooms: 2,
    bathrooms: 2,
    property_type: "Student Housing",
    availability_date: "Available Now",
    is_available: true,
    amenities: [
      "Ground-floor walk-out patio",
      "2 full bathrooms",
      "In-suite laundry",
      "Open-concept living",
      "Close to campus"
    ],
    images: [
      "https://lh3.googleusercontent.com/d/13PbVUsoLH4NUlHxGcmZwehCkU_mClSx8",
      "https://lh3.googleusercontent.com/d/13P_0r8pTJMYB4uMgStAkH_ktWTnksSyu",
      "https://lh3.googleusercontent.com/d/13J86KrgRauok4O886NWB-5uMyUvH945z",
      "https://lh3.googleusercontent.com/d/13ItqaXrkjjAOu1f9uDHl-jkGi0CTAlAY",
      "https://lh3.googleusercontent.com/d/13HTn3ujwUJyMp3BxdSiXUROgn2FYqWAj",
      "https://lh3.googleusercontent.com/d/13HFK27jiP6ms-v0QmzpujsjtphUbaaSy",
      "https://lh3.googleusercontent.com/d/13EBgQAp_H4bvWNg7hXgibU7XAFpa_U6G",
      "https://lh3.googleusercontent.com/d/13PilGohvG0JFbDnot5Ngd8wBbJ4gFZ9S",
      "https://lh3.googleusercontent.com/d/132VT3NnVtFzQhEZb0XWYihuCKy2fj_EM",
      "https://lh3.googleusercontent.com/d/13S9UMbmM-2rxFUrjXUgSs-Q3_zej7aMp",
      "https://lh3.googleusercontent.com/d/13QSULMZk82kwUSc6rVTIrV2IshDxkeEa",
      "https://lh3.googleusercontent.com/d/13PoYtNbhALoUHUFKo40sPEBSgndYoPfK"
    ],
    contact_info: "Lyle Patel",
    whatsapp_link: "https://api.whatsapp.com/message/RBQYKNFZADHKI1?autoload=1&app_absent=0",
    drive_folder: "https://drive.google.com/drive/folders/1K4P5uI0Oa1rI7oNQFNjPKP0ZbOmgT8Hf"
  },
  {
    id: "unit-101-935-academy-way",
    title: "Unit 101 – 935 Academy Way",
    description: "A bright and modern 3-bedroom, 2-bathroom corner suite with an open living space and private balcony. This unit is ideal for students or professionals looking to share a spacious home just minutes from UBCO.",
    address: "935 Academy Way, Kelowna, BC", 
    rent: "Contact to know more",
    bedrooms: 3,
    bathrooms: 2,
    property_type: "Student Housing",
    availability_date: "Available Now",
    is_available: true,
    amenities: [
      "3 bedrooms, 2 bathrooms",
      "Stainless steel kitchen appliances",
      "Private balcony",
      "In-suite laundry",
      "Prime location near UBCO"
    ],
    images: [
      "https://lh3.googleusercontent.com/d/10MlT4dw4PC5nxqCVXELTiXnsS4GGb1d7",
      "https://lh3.googleusercontent.com/d/14rFROZ-eYqtgMnQazjHWdEr49io5q4M7",
      "https://lh3.googleusercontent.com/d/15ziEaoS4yB6m00HCNvp58St7pSuVicZw",
      "https://lh3.googleusercontent.com/d/1EXZHNVOMc5nz5ydmiajDUWTyH7HMIKFX",
      "https://lh3.googleusercontent.com/d/1F8E-8L1MSpxCAyRbWEoZtmn4wurGmhYo",
      "https://lh3.googleusercontent.com/d/1FpMBIcg1m4ZFoIFBctI6xdrR8XCpd9J4",
      "https://lh3.googleusercontent.com/d/1H3c8arPl3BZk1YztU4IOyowvu95CoaJr",
      "https://lh3.googleusercontent.com/d/1LfeRa46EqI6TAi_wI-nsiFZoZF2SVqzL",
      "https://lh3.googleusercontent.com/d/1Nd5BFMDPnDwrDLVzr4JI5aNv-vWdi3Hi",
      "https://lh3.googleusercontent.com/d/1RuH3TOBqlpD-bcmbXYonnowiKvRUSuAG",
      "https://lh3.googleusercontent.com/d/1U_RhEe4-C7PF6HyB7JifKEOl3ZsEk2g0",
      "https://lh3.googleusercontent.com/d/1WG0kfgZhNs22ettHterw1V7yVbrHJvbO",
      "https://lh3.googleusercontent.com/d/1_KcBkKPfPHRkj55zdgdbUBkE-nsaErUN",
      "https://lh3.googleusercontent.com/d/1jbxKrmpgDYaQX36vW-Go_vo-zNjvXCMj",
      "https://lh3.googleusercontent.com/d/1mKMNSH92BdPWpWXLSOjXCe-gW84Dq0t_",
      "https://lh3.googleusercontent.com/d/1mxv4EkjGSqxdc-CKj8ZkcI8dvnIObr4u",
      "https://lh3.googleusercontent.com/d/1qQbeYPS3dHoyQ9ZB85hesaxHRMFtCc8l",
      "https://lh3.googleusercontent.com/d/1sejQQS0earLiB8ztenUsfcexgPub4yzU",
      "https://lh3.googleusercontent.com/d/1wgetrqXU7go40QkhFN4jPC5HEbXE9bWy",
      "https://lh3.googleusercontent.com/d/1zQ1jckn1NiJ6Enkt8SJII3yHorK3gYLi"
    ],
    contact_info: "Lyle Patel",
    whatsapp_link: "https://api.whatsapp.com/message/RBQYKNFZADHKI1?autoload=1&app_absent=0",
    drive_folder: "https://drive.google.com/drive/folders/1X6fLq2wVzL9sT4GpM3eRb7AaJ8YuK5Dc"
  },
  {
    id: "unit-115-935-academy-way", 
    title: "Unit 115 – 935 Academy Way",
    description: "Enjoy the perfect blend of function and comfort in this sunlit 2-bedroom, 2-bathroom home with a private balcony. Located in a secure building, it features a fully equipped kitchen, in-suite laundry, and convenient access to UBCO and transit.",
    address: "935 Academy Way, Kelowna, BC",
    rent: "Contact to know more", 
    bedrooms: 2,
    bathrooms: 2,
    property_type: "Student Housing",
    availability_date: "Available Now",
    is_available: true,
    amenities: [
      "2 full bathrooms",
      "Open living and kitchen area",
      "In-suite laundry", 
      "Balcony with green views",
      "Close to campus and shops"
    ],
    images: [
      "https://lh3.googleusercontent.com/d/10OcI8qG2Hv3gAvWGciu-9KE8SF5v3RFK",
      "https://lh3.googleusercontent.com/d/10PGiMcp-mN7pdJEgYrQJayl8m3POUBoI",
      "https://lh3.googleusercontent.com/d/10TEg2T3xeUEeero6NjMH2qQbG-nx_KgN",
      "https://lh3.googleusercontent.com/d/10ar8OcJ_oS5d_wTKIissqcMIGwv_9jXX",
      "https://lh3.googleusercontent.com/d/10e0Lp7iF8oMi3fJKjef8tWdsprPHzaUt",
      "https://lh3.googleusercontent.com/d/10g--LX-3O1maC_GT0PUZPwSAudtUIH4h",
      "https://lh3.googleusercontent.com/d/10gItNu_NKbc4XxuiVremHs_qo6ytUhCA",
      "https://lh3.googleusercontent.com/d/10gyc8NLy6NmZ760GrszNg2rBycZ06O2R",
      "https://lh3.googleusercontent.com/d/10lkLEkKWJhoa5XDLxxkMbBrflRCmxgEL",
      "https://lh3.googleusercontent.com/d/10mZ2M84jfc3sEGU2RJayjBL-qBWmAcd_"
    ],
    contact_info: "Lyle Patel",
    whatsapp_link: "https://api.whatsapp.com/message/RBQYKNFZADHKI1?autoload=1&app_absent=0",
    drive_folder: "https://drive.google.com/drive/folders/1h9W2zF5nE4xU6kVs2DcJy8PqL1BgR7Tm"
  },
  {
    id: "unit-326-935-academy-way",
    title: "Unit 326 – 935 Academy Way", 
    description: "Top-floor living with this spacious 3-bedroom, 2-bathroom suite offering mountain views and modern design. The unit includes a private balcony, full kitchen, and in-suite laundry—all within walking distance of UBCO.",
    address: "935 Academy Way, Kelowna, BC",
    rent: "Contact to know more",
    bedrooms: 3,
    bathrooms: 2,
    property_type: "Student Housing", 
    availability_date: "Available Now",
    is_available: true,
    amenities: [
      "3 bedrooms, 2 full bathrooms",
      "Balcony with hillside views",
      "Full kitchen and in-suite laundry",
      "Secure building with elevator access", 
      "Ideal for students or young professionals"
    ],
    images: [
      "https://lh3.googleusercontent.com/d/12DRgIdS7BXO5jMlco1bJGlHTowSVczTd",
      "https://lh3.googleusercontent.com/d/12Dak3tueZt4X0e9bgBI6WBtFwx003d6K",
      "https://lh3.googleusercontent.com/d/12HTdqafUrth0jKYB5BYUogqgPnIgb1kP",
      "https://lh3.googleusercontent.com/d/12NUBO5iWgNaZbD0sH2eGMV-JsIqdnLKH",
      "https://lh3.googleusercontent.com/d/12OiMhsLa3nwjxeKsRp_qjOP8QAstLOvS",
      "https://lh3.googleusercontent.com/d/12W0xPzV1c0uk2PCnKWQmXQ-yUmHfkC1m",
      "https://lh3.googleusercontent.com/d/12WIecvDyktxfiDDt0P72gbvWuG3p8l_t",
      "https://lh3.googleusercontent.com/d/12c7ixnP5H6TVF_tdqsvbj3imE0KnnMzL",
      "https://lh3.googleusercontent.com/d/12g5V75wjRLmn9Wx-xr_DS7MIMgEpywSv",
      "https://lh3.googleusercontent.com/d/12hyBTCnA5uIrOi7cvRIMIvs0W56_ZzPy",
      "https://lh3.googleusercontent.com/d/12w_M-wIfqujm6bQ_YCuzkKyENVYNh2UJ",
      "https://lh3.googleusercontent.com/d/12wlEU7LOrv60lLC4QBpvHNB7-qh_O7r2",
      "https://lh3.googleusercontent.com/d/12wuX-kKCMtVLQjAFlJqV1-K8afYldjsQ",
      "https://lh3.googleusercontent.com/d/13--C29GSdgdB24-KgU3_lnVHdbxdDOve",
      "https://lh3.googleusercontent.com/d/130u-LdaXhhJgaDZ1P0Rmgqq1W-czoMOF"
    ],
    contact_info: "Lyle Patel",
    whatsapp_link: "https://api.whatsapp.com/message/RBQYKNFZADHKI1?autoload=1&app_absent=0",
    drive_folder: "https://drive.google.com/drive/folders/1A7sP9qE2mC8wX5vL6BtNj4KuF3YdG0Rh"
  }
];